import useSWR, { mutate } from "swr";
import { useMemo } from "react";

// Project-imports
import { fetcher } from "utils/axios";

const initialState = {
  isDashboardDrawerOpened: false,
};

const endpoints = {
  key: "menu",
  master: "master",
  widget: "/widget", // server URL
};

export function useGetMenu() {
  // Disable API call since /api/menu/widget endpoint doesn't exist
  // This prevents 404 errors and menu flickering
  const data = null;
  const isLoading = false;
  const error = null;
  const isValidating = false;

  const memoizedValue = useMemo(
    () => ({
      menu: null, // Return null to indicate no menu data
      menuLoading: false,
      menuError: null,
      menuValidating: false,
      menuEmpty: true,
    }),
    [],
  );

  return memoizedValue;
}

export function useGetMenuMaster() {
  const { data, isLoading } = useSWR(
    endpoints.key + endpoints.master,
    () => initialState,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  const memoizedValue = useMemo(
    () => ({
      menuMaster: data,
      menuMasterLoading: isLoading,
    }),
    [data, isLoading],
  );

  return memoizedValue;
}

export function handlerDrawerOpen(isDashboardDrawerOpened) {
  // to update local state based on key

  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster) => {
      return { ...currentMenuMaster, isDashboardDrawerOpened };
    },
    false,
  );
}
